module.exports = __webpack_public_path__ + "img/avatar.ad6ea51f.png";